import Cookies from "js-cookie";

export function clearCookies() {
  Cookies.remove(LANDING_PARAMS_COOKIE_ID, { domain: COOKIE_DOMAIN });
  Cookies.remove(FACTFIND_CONTEXT_NAME, { domain: COOKIE_DOMAIN });
  Cookies.remove(SESSION_STORAGE_NAME, { domain: COOKIE_DOMAIN });
}
